"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {};
tokens._getCss = function () {return `/* imported from empty.css */`;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/src/components/empty_css.js"};
exports["default"] = tokens;